import React from 'react'
import { Link } from 'react-router-dom'
import VipLayout from '../../components/vip/VipLayout'

const VipAboutPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">About Us</span>
          <h1>关于我们</h1>
          <p>广东凡思彼得科技有限公司以人工智能（AI）技术为核心驱动力的高科技公司。我们专注于为全球企业和客户提供领先的AI解决方案与数字营销服务，连接企业互联网商业资质需求与 AI 时代的新型合规需求。</p>
          <p>我们聚焦企业工商财税、知识产权、互联网经营资质、AI 大模型登记与备案、开源大模型私有化部署、企业知识库训练与微调，以及社区 / 音视频 / AIGC 服务资质咨询，为企业提供更清晰、更专业、更高效的咨询与申报辅导服务。</p>
          <Link to="/vip/platform" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>我要了解更多</Link>
        </div>
      </section>
      <section className="section">
        <div className="container two-col">
          <div>
            <h2 className="section-title">我们的定位</h2>
            <p className="section-desc">公司业务范围广泛，涵盖数字人、AIGC（人工智能生成内容）、行业大模型与智能体开发与应用，以及本土化数字营销服务。通过自主研发与技术创新，在AI新兴服务行业中处于技术与产品的前沿位置，致力于推动AI技术在全球各行业的深度应用与商业化落地。</p>
          </div>
          <div className="card content-card">
            <h3>我们的核心能力</h3>
            <ul className="list">
              <li>AI 解决方案与数字营销服务</li>
              <li>数字人、AIGC 与行业大模型开发</li>
              <li>智能体开发与应用</li>
              <li>企业互联网商业资质与合规咨询</li>
            </ul>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default VipAboutPage
